import { render } from "./AppLoaderFull.vue?vue&type=template&id=6fd736b4&scoped=true"
const script = {}

import "./AppLoaderFull.vue?vue&type=style&index=0&id=6fd736b4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd736b4"]])

export default __exports__